if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickyButton = document.getElementById(`StickySubmitButton-${this.sectionId}`);
        this.stickyPrice = document.getElementById(`StickyPrice-${this.sectionId}`);
        this.observer = null;
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        if (!this.mainButton || !this.stickyButton) return;

        this.stickyButton.addEventListener('click', this.onStickyClick.bind(this));

        this.observer = new IntersectionObserver(
          (entries) => {
            const isVisible = entries.some((entry) => entry.isIntersecting);
            this.classList.toggle('is-visible', !isVisible);
            this.setAttribute('aria-hidden', isVisible ? 'true' : 'false');
          },
          { threshold: 0, rootMargin: '0px 0px -8px 0px' }
        );
        this.observer.observe(this.mainButton);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.updateFromVariantChange(event.data);
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      onStickyClick() {
        if (this.stickyButton.disabled) return;
        this.mainButton?.click();
      }

      updateFromVariantChange({ html, variant }) {
        if (html && this.stickyPrice) {
          const sourcePrice = html.getElementById(`price-${this.sectionId}`);
          if (sourcePrice) this.stickyPrice.innerHTML = sourcePrice.innerHTML;
        }

        const sourceButton = html?.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const isDisabled = sourceButton?.hasAttribute('disabled') ?? !variant?.available;

        this.stickyButton.disabled = isDisabled;
        const label = this.stickyButton.querySelector('span');
        if (!label) return;

        if (!variant) {
          label.textContent = window.variantStrings?.unavailable || 'Unavailable';
        } else if (isDisabled) {
          label.textContent = window.variantStrings?.soldOut || 'Sold out';
        } else {
          label.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }
    }
  );
}
